export const USER_INPUT_USER_NAME_CHANGE = 'USER_INPUT_USER_NAME_CHANGE';
export const USER_INPUT_APP_KEY_CHANGE = 'USER_INPUT_APP_KEY_CHANGE';
export const USER_INPUT_PASSWORD_CHANGE = 'USER_INPUT_PASSWORD_CHANGE';
export const USER_INPUT_PASSWORD_LESS_OTP_CHANGE = 'USER_INPUT_PASSWORD_LESS_OTP_CHANGE';
export const USER_INPUT_CAPTCHA_RESPONSE = 'USER_INPUT_CAPTCHA_RESPONSE';
export const PASSWORD_LESS_SAML_CONFIG = 'PASSWORD_LESS_SAML_CONFIG';
export const USER_INPUT_TFA_PASSCODE_CHANGE = 'USER_INPUT_TFA_PASSCODE_CHANGE';
export const USER_INPUT_TFA_DELIVERY_PREFERENCE_CHANGE = 'USER_INPUT_TFA_DELIVERY_PREFERENCE_CHANGE';
export const USER_INPUT_CHANGE_EMAIL_VERIFIED = 'USER_INPUT_CHANGE_EMAIL_VERIFIED';
export const USER_INPUT_EMAIL_CHANGED = 'USER_INPUT_EMAIL_CHANGED';
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';

export const AUTH_SESSION = 'AUTH_SESSION';
export const TFA_STATE = 'TFA_STATE';
export const EULA_STATE = 'EULA_STATE';
export const AUTH_MODE_STATE = 'AUTH_MODE_STATE';
export const SAVED_AUTH_PARAM = 'SAVED_AUTH_PARAM';
export const AUTHENTICATED_USER = 'AUTHENTICATED_USER';
export const AUTHENTICATION_PARAMETERS = 'AUTHENTICATION_PARAMETERS';
export const REFERENCE_DATA = 'REFERENCE_DATA';
export const USER_PROFILE = 'USER_PROFILE';
export const SSO_ENV = 'SSO_ENV';
export const USER_DASHBOARD_CONFIG = 'USER_DASHBOARD_CONFIG';
export const GLOBAL_ID_TRANSITION = 'GLOBAL_ID_TRANSITION';
export const GLOBAL_ID_TRANSITION_CLEAR = { errTransition: false, errNoGlobal: false, errAttemptsExceeded: false, token: '', remainingAttempts: '', email: '' };
export const ERR_TRANSITION_TO_GLOBAL_ID = 'ERR_TRANSITION_TO_GLOBAL_ID';
export const TRANSITION_TO_GLOBAL_ID_TOKEN = 'TRANSITION_TO_GLOBAL_ID_TOKEN';
export const ERR_TRANSITION_TO_GLOBAL_ID_NOGLOBAL = 'ERR_TRANSITION_TO_GLOBAL_ID_NOGLOBAL';
export const CONTINUE_WITH_APPID_CLICK = 'CONTINUE_WITH_APPID_CLICK';
export const ERR_MSG = 'ERROR_MESSAGE';
export const PASSWORD_EXPIRED = 'PASSWORD_EXPIRED';
export const MAX_SESSIONS_EXCEED = 'MAX_SESSIONS_EXCEED';
export const USER_HAS_EXISTING_SESSIONS = 'USER_HAS_EXISTING_SESSIONS';
export const ERR_TRANSITION_TO_GLOBAL_GLOBAL_ID_PRESENT_APP_ID_ATTEMPTS_EXCEEDED = 'ERR_TRANSITION_TO_GLOBAL_GLOBAL_ID_PRESENT_APP_ID_ATTEMPTS_EXCEEDED';
export const EMAIL_DELIVERY = 'EMAIL';
export const WEBAUTHN_DELIVERY = 'WEBAUTHN';
export const GOOGLE_AUTH_DELIVERY = 'ICE_MOBILE_APP';
export const REGISTER_ACTION = 'REGISTER_ACTION';
export const WEBAUTHN_DETAILS = 'WEBAUTHN_DETAILS';
export const SESSION_EXPIRED_DIALOG = 'SESSION_EXPIRED_DIALOG';
export const CONNECTION_TEST_STATE = 'CONNECTION_TEST_STATE';
